import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../shared/components/svg-image/svg-image';
import reset from '../../shared/components/html-content/reset.style';
import { TranslationKey, i18n } from '../../i18n/i18n';
import '../../shared/components/svg-image/svg-image';
import { overrideDesignTokens } from '../../shared/styles/override-design-tokens';

/**
 * Error state placeholder
 */
@customElement('luds-error')
export class LudsError extends LitElement {
  static override styles = [
    reset,
    overrideDesignTokens,
    css`
      section {
        text-align: center;
        display: block;
      }
    `,
  ];

  @property()
  image: string;

  @property()
  override title: TranslationKey;

  @property()
  description?: TranslationKey;

  @property()
  subtitle?: TranslationKey;

  protected override render() {
    const description = this.description ? html`<p>${i18n(this.description)}</p>` : nothing;
    const subtitle = this.subtitle ? html`<strong>${i18n(this.subtitle)}</strong>` : nothing;

    return html`
      <section>
        <lua-svg-image .name="${this.image}"></lua-svg-image>
        <h1>${this.title && i18n(this.title)}</h1>
        ${description} ${subtitle}
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'luds-error': LudsError;
  }
}
